import { useMemo } from 'react';

import { useAppSelector } from '@/store/hooks';
import { getChannels } from '@/store/slices/channels/selectors';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { ChannelFeaturesEnum } from '@/types/feature-flags.types';

const useCanUseChannelFeature = (feature: ChannelFeaturesEnum) => {
  const activeChannel = useAppSelector(getActiveChannel);
  const channels = useAppSelector(getChannels);
  const channel = channels?.find((c) => c.channel === activeChannel);
  const enabledFeatures = channel?.enabled_features;
  return useMemo(() => (enabledFeatures || []).includes(feature), [enabledFeatures, feature]);
};

export default useCanUseChannelFeature;
